import { Attr, BelongsTo, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import RecruiterUser from "./RecruiterUser";

@Model()
class CandidateQualifier extends ApplicationRecord {
  static jsonapiType = "candidate_qualifiers";

  @Attr() list: string;

  @BelongsTo(RecruiterUser) recruiterUser: RecruiterUser;
}

export default CandidateQualifier;
